import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { history } from "src/App";
import { cancel } from "src/utils/axios";

import { logout } from "_common/actions/auth.action";

import avt from "./profile.png";

export const CAccount = () => {
  //#region Datas
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const [open, setOpen] = useState(false);
  //#endregion

  //#region Events
  const onToggle = () => setOpen(!open);

  const onLogout = () => {
    cancel();
    dispatch(logout());
  };
  //#endregion

  //#region Render
  return (
    <div className="relative">
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={onToggle}
      >
        <img src={avt} alt="" className="max-w-10" />
        <span className="text-white font-medium ">{user?.name ?? ""}</span>
      </div>

      {open && (
        <>
          <div
            className="menu-backdrop fixed z-[49] top-0 left-0 h-screen w-screen bg-[#c5c5c51f]"
            onClick={() => setOpen(false)}
          ></div>
          <div className="absolute w-full top-14 bg-white shadow-xl rounded-xl z-50 overflow-hidden border-[1px] border-solid !border-gray-300">
            <div>
              <p className="text-center text-sm select-none text-gray-500 font-semibold !py-2 mb-0 bg-gray-100">
                Setting
              </p>
              <p
                className="!px-5 !py-2 mb-0 cursor-pointer hover:bg-gray-100"
                onClick={() => history.push("/profile")}
              >
                Profile
              </p>
            </div>
            <div className="min-h-[1px] border-t border-solid border-gray-300"></div>
            <p
              className="!px-5 !py-2 mb-0 cursor-pointer hover:bg-gray-100"
              onClick={onLogout}
            >
              Logout
            </p>
          </div>
        </>
      )}
    </div>
  );
  //#endregion
};

// const Rac = () => {
//   return (
//     <CDropdown
//       inNav
//       className="c-header-nav-items c-header-nav-account"
//       direction="down"
//     >
//       <CDropdownToggle className="c-header-nav-link" caret={false}>
//         <div className="c-avatar">
//           <CImg className="c-avatar-img" src={avt} alt={user?.email} />
//         </div>
//         <span>{user?.name || ""}</span>
//       </CDropdownToggle>
//       <CDropdownMenu className="pt-0" placement="bottom-end">
//         <CDropdownItem header tag="div" color="light" className="text-center">
//           <strong>Account</strong>
//         </CDropdownItem>
//         <CDropdownItem>
//           <CIcon name="cil-bell" className="mfe-2" />
//           Updates
//           <CBadge color="info" className="mfs-auto">
//             42
//           </CBadge>
//         </CDropdownItem>
//         <CDropdownItem>
//           <CIcon name="cil-envelope-open" className="mfe-2" />
//           Messages
//           <CBadge color="success" className="mfs-auto">
//             42
//           </CBadge>
//         </CDropdownItem>
//         <CDropdownItem>
//           <CIcon name="cil-task" className="mfe-2" />
//           Tasks
//           <CBadge color="danger" className="mfs-auto">
//             42
//           </CBadge>
//         </CDropdownItem>
//         <CDropdownItem>
//           <CIcon name="cil-comment-square" className="mfe-2" />
//           Comments
//           <CBadge color="warning" className="mfs-auto">
//             42
//           </CBadge>
//         </CDropdownItem>
//         <CDropdownItem header tag="div" color="light" className="text-center">
//           <strong>Settings</strong>
//         </CDropdownItem>
//         <CDropdownItem to="/profile">
//           <CIcon name="cil-user" className="mfe-2" />
//           Profile
//         </CDropdownItem>
//         <CDropdownItem>
//           <CIcon name="cil-settings" className="mfe-2" />
//           Settings
//         </CDropdownItem>
//         <CDropdownItem>
//           <CIcon name="cil-credit-card" className="mfe-2" />
//           Payments
//           <CBadge color="secondary" className="mfs-auto">
//             42
//           </CBadge>
//         </CDropdownItem>
//         <CDropdownItem>
//           <CIcon name="cil-file" className="mfe-2" />
//           Projects
//           <CBadge color="primary" className="mfs-auto">
//             42
//           </CBadge>
//         </CDropdownItem>
//         <CDropdownItem divider />
//         <CDropdownItem onClick={onLogout}>
//           <CIcon name="cil-lock-locked" className="mfe-2" />
//           Logout
//         </CDropdownItem>
//       </CDropdownMenu>
//     </CDropdown>
//   );
// };
